import classNames from 'classnames';
import * as React from 'react';
import useNavBarPosition from '../../hooks/useNavBarPosition';
import Stormotion from '../icons/Stormotion';
import Link from '../Link';
import NavigationMenu from '../NavigationMenu';
import './style.scss';
import { PageLanguage } from '../../utils/langaugeTypes';

interface Props {
  headerBackgroundColor: 'none' | 'light';
  currentPage?: string;
  shadowed?: boolean;
  transparent?: boolean;
  pageLanguages?: PageLanguage[];
}

const Navigation: React.FC<Props> = ({
  headerBackgroundColor,
  currentPage,
  shadowed = true,
  transparent = true,
  pageLanguages,
}) => {
  const [hamClicked, onHamClick] = React.useState(false);

  const onTop = useNavBarPosition();

  React.useEffect(() => {
    const body = document.getElementsByTagName('body');

    body[0].className = hamClicked ? 'opened' : '';
  }, [hamClicked]);

  return (
    <nav
      className={classNames('navigation', {
        open: hamClicked,
        scrolled: !onTop || !transparent,
        shadowed: shadowed && !onTop,
      })}
    >
      <div className="nav-bar">
        <Link href="/">
          <Stormotion
            dark={hamClicked || headerBackgroundColor === 'light' || !onTop}
          />
        </Link>
        <NavigationMenu
          isOpen={hamClicked}
          onHamClick={onHamClick}
          isOnTop={onTop}
          currentPage={currentPage}
          headerBackgroundColor={hamClicked ? 'light' : headerBackgroundColor}
          pageLanguages={pageLanguages}
        />
      </div>
    </nav>
  );
};

export default Navigation;
